import { ConcreteEncodable } from "./ConcreteEncodable";

import { ServiceResponseImplEncoder } from "../../encoder/ServiceResponseImplEncoder";

import * as CubiqTS from "../../index";
import { ServiceResponse } from "../ServiceResponse";

export class ServiceResponseImpl extends ConcreteEncodable implements ServiceResponse {
  public static enType: string = "com.bcdfx.service.impl.ServiceResponseImpl";

  /*FID=1*/
  public errorList: CubiqTS.Errors | null = null;
  /*FID=2*/
  public payload: CubiqTS.Encodable | null = null;
  /*FID=3*/
  public responseCode: CubiqTS.ResponseCode;
  /*FID=4*/
  public serviceRequestType: string;
  /*FID=5*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=6*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=7*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=8*/
  public cliRxTime: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ServiceResponseImplEncoder.Instance;
    this.setEncodableType(ServiceResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ServiceResponseImpl[" +
      "errorList=" +
      this.errorList +
      "payload=" +
      this.payload +
      "responseCode=" +
      this.responseCode +
      "serviceRequestType=" +
      this.serviceRequestType +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
